import CloudintellitechUI from '@cloudintellitech/ui'
import VWave from 'v-wave'
import WujieVue from 'wujie-vue3'
// 加载 iconify 图标
import { downloadAndInstall } from '@/iconify'
import icons from '@/iconify/index.json'
import {
  AI_EMPLOYEE_CONSOLE_APP_NAME,
  AI_EMPLOYEE_CONSOLE_RESET_EVENT,
  AI_EMPLOYEE_CONSOLE_SESSION_CHANGED_EVENT,
} from '@/store/modules/aiEmployeeConsole'
import {
  NEW_AI_EMPLOYEE_CONSOLE_APP_NAME,
  NEW_AI_EMPLOYEE_CONSOLE_RESET_EVENT,
  newAiEmployeeConsoleBus,
} from '@/store/modules/newAiEmployeeConsole'
// 自定义指令
import directive from '@/utils/directive'
// 错误日志上报
import errorLog from '@/utils/errorLog'
import eventBus from '@/utils/eventBus'
// 企业微信工具
import { isWecomEnvironment, registerWecomJsSDK } from '@/utils/wecom'
import App from './App.vue'

import i18n from './locales'
import router from './router'
import pinia from './store'
import uiProvider from './ui/provider'
// 自定义样式
import '@/assets/styles/custom.css'
import '@/utils/storage'
import '@/utils/systemCopyright'

import '@cloudintellitech/ui/style.css'
// 加载 svg 图标
import 'virtual:svg-icons-register'
// UnoCSS
import '@unocss/reset/tailwind-compat.css'
import 'virtual:uno.css'
// 全局样式
import '@/assets/styles/globals.css'
// CIT UI 品牌主题及现有组件库兼容层
import '@cloudintellitech/ui/themes.css'
import '@cloudintellitech/ui/compat/shadcn.css'
import '@cloudintellitech/ui/compat/element-plus.css'

const app = createApp(App)
app.use(VWave, {})
app.use(WujieVue)
app.use(pinia)
app.use(router)
app.use(uiProvider)
app.use(CloudintellitechUI)
app.use(i18n)
directive(app)
errorLog(app)
eventBus.on(AI_EMPLOYEE_CONSOLE_RESET_EVENT, () => {
  WujieVue.bus.$emit(AI_EMPLOYEE_CONSOLE_SESSION_CHANGED_EVENT, { active: false })
  void WujieVue.destroyApp(AI_EMPLOYEE_CONSOLE_APP_NAME).catch(() => undefined)
})
eventBus.on(NEW_AI_EMPLOYEE_CONSOLE_RESET_EVENT, () => {
  newAiEmployeeConsoleBus.$emit(AI_EMPLOYEE_CONSOLE_SESSION_CHANGED_EVENT, { active: false })
  void WujieVue.destroyApp(NEW_AI_EMPLOYEE_CONSOLE_APP_NAME).catch(() => undefined)
})
if (icons.isOfflineUse) {
  for (const info of icons.collections) {
    downloadAndInstall(info)
  }
}

// 如果在企业微信环境中，自动注册 JS-SDK
if (isWecomEnvironment()) {
  registerWecomJsSDK().catch((err) => {
    console.warn('企业微信 JS-SDK 自动注册失败:', err)
  })
}

app.mount('#app')
